import { ChangeHospital } from 'domain/usecases/hospital/change-hospital'
import { HospitalRepository } from 'repository/interfaces/hospital-repository'

export class RemoteChangeHospital implements ChangeHospital {
  private readonly hospitalRepository: HospitalRepository

  constructor(hospitalRepository: HospitalRepository) {
    this.hospitalRepository = hospitalRepository
  }

  update(params: ChangeHospital.Params): Promise<ChangeHospital.Model> {
    return this.hospitalRepository.changeHospital(params)
  }
}

export type ChangePasswordModel = ChangeHospital.Model
